<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M13.3075 15.3683C13.5898 15.6483 13.9709 15.8061 14.3684 15.8078C14.7862 15.8514 15.2033 15.7196 15.5202 15.4441C15.5445 15.4213 15.568 15.3978 15.5908 15.3735C16.1628 14.7625 16.1312 13.8034 15.5202 13.2313L10.1395 7.8821L15.5202 2.50135C15.997 1.91344 15.9668 1.06395 15.4497 0.511273C14.8778 -0.0998996 13.9187 -0.131691 13.3076 0.440204L7.99632 5.75148L2.57755 0.364428C2.01019 -0.121476 1.17339 -0.121476 0.605983 0.364428C-0.0297439 0.908873 -0.103757 1.86561 0.440638 2.50133L5.84354 7.90426L0.440712 13.3071C-0.146904 13.8982 -0.146904 14.8529 0.440712 15.444C0.738662 15.7001 1.12445 15.8306 1.51673 15.8077C1.90386 15.8266 2.28346 15.6965 2.57757 15.444L7.98043 10.0412L13.3075 15.3683Z"
      fill="white" />
  </svg>
</template>
<script>
export default {
  name: "CloseIcon",
};
</script>